import compareAsc from 'date-fns/compareAsc';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';

import { recordException } from './reporting';

export const noop = null;

export const readLastUpdatedDate = (arr) => {
  if (arr && arr.length > 0) {
    const lastUpdateDate = arr.map(
      (item) => new Date(item.updatedDatetime)
    ).sort().reverse()[0];
    return format(lastUpdateDate, 'MM/dd/yyyy');
  }
  return null;
};

export const formatUTCDate = (dateStr, pattern = 'MMMM dd, yyyy', emptyValue = '') => {
  if (!dateStr) {
    return emptyValue;
  }
  try {
    const parsedDate = parseISO(dateStr);
    return format(parsedDate, pattern);
  } catch (err) {
    recordException(err);
    return emptyValue;
  }
};

export const getMostEarliesttDateByKey = (arrObj, dateKey) => arrObj?.sort(
  (objA, objB) => {
    if (!objA && objA[dateKey]) {
      return 1;
    }

    if (!objB && objB[dateKey]) {
      return -1;
    }
    return compareAsc(new Date(objA && objA[dateKey]), new Date(objB && objB[dateKey]));
  }
)?.[0] ?? {};

export const getMostRecentDateByKey = (arrObj, dateKey) => arrObj?.sort(
  (objA, objB) => {
    if (!objA && objA[dateKey]) {
      return 1;
    }

    if (!objB && objB[dateKey]) {
      return -1;
    }
    return compareAsc(new Date(objB && objB[dateKey]), new Date(objA && objA[dateKey]));
  }
)?.[0] ?? {};

export const filterDateRangeByKey = (arrObj, dateKey, startDate, endDate) => (
  arrObj.filter((dateObj) => {
    const dateValue = new Date(dateObj[dateKey]);
    return (dateValue >= startDate && dateValue <= endDate);
  })
);

export const filterUpperRangeDateByKey = (arrObj, dateKey, startDate) => (
  arrObj.filter((dateObj) => {
    const dateValue = new Date(dateObj[dateKey]);
    return (dateValue >= startDate);
  })
);

export const getGreetingByTime = () => {
  const currentHour = new Date().getHours();

  if (currentHour < 12) {
    return 'Good morning';
  } if (currentHour < 18) {
    return 'Good afternoon';
  }
  return 'Good evening';
};

export const getDate = (data) => {
  // TODO: Verify data format when available try/catch for handling format errors
  const [year, month, day] = data.split('-');
  const date = new Date(year, month - 1, day);
  return date;
};

export const getFormattedDate = (date) => {
  // yyyy-mm-dd
  const datef = getDate(date);
  const fdate = datef.toLocaleString('default', {
    day: 'numeric',
    month: 'long'
  });
  return fdate;
};

export const JS_EARLIEST_DATE = -8640000000000000; // earliest date in milisseconds per js spec
